module.exports = __webpack_public_path__ + "img/circle-s.9042ae6e.svg";